module.exports = __webpack_public_path__ + "img/transmission_and_traction.70f72f88.svg";